import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MultiSelectOptionViewModelType from '@/ViewModels/Controls/MultiSelectOptionViewModel';
import LabelType from '@/Controls/Label';

export default class MultiSelectOption extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;
    private label: LabelType;

    public constructor(private viewModel: MultiSelectOptionViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<option>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'multiselectoption',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            visible: this.viewModel.isVisible,

            focus: this.viewModel.isFocusable,

            locator: this.viewModel.locator,

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isSelected() === true) {
                        states.push('selected');
                    }

                    return states;
                }
            }),

            value: this.viewModel.value
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('MultiSelectOption', MultiSelectOption, 'RADPresentation.HTMLClient.DefaultViewExtensions');